import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/home";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = window.setInterval(() => setActive((v) => (v + 1) % total), 5500);
    return () => window.clearInterval(timer);
  }, [total]);

  const go = (dir: number) => setActive((v) => (v + dir + total) % total);

  return (
    <section className="relative w-full h-[520px] md:h-[600px] overflow-hidden bg-foreground-950">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === active ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            title={`${slide.title} - 筱田优影视品牌官方网站`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-foreground-950/45" />
        </div>
      ))}

      <div className="relative z-10 h-full w-full px-4 md:px-8 flex items-end pb-16 md:pb-24">
        <div className="w-full max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-4">
            <i className="ri-fire-line" />
            最新动态
          </span>
          <h1 className="font-heading text-3xl md:text-5xl font-black text-background-50 leading-tight animate-fade-up">
            {heroSlides[active].title}
          </h1>
          <p className="text-sm md:text-lg text-background-50/85 mt-4 max-w-2xl leading-relaxed animate-fade-up">
            {heroSlides[active].subtitle}
          </p>
          <div className="flex flex-wrap items-center gap-3 mt-7">
            <Link
              to={`/news/${heroSlides[active].newsId}`}
              className="px-6 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center gap-2"
            >
              阅读详情
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/works"
              className="px-6 h-11 rounded-md border border-background-50/50 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap flex items-center gap-2"
            >
              浏览作品
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(-1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-background-50/15 text-background-50 hover:bg-background-50/30 backdrop-blur transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-background-50/15 text-background-50 hover:bg-background-50/30 backdrop-blur transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl" />
      </button>

      <div className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {heroSlides.map((slide, index) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第 ${index + 1} 张`}
            onClick={() => setActive(index)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              index === active ? "w-8 bg-accent-500" : "w-3 bg-background-50/50 hover:bg-background-50/80"
            }`}
          />
        ))}
      </div>
    </section>
  );
}